/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ICheckEstimationRequestExistsResponse {
  /** Есть ли телефон **/
  phoneExists: boolean;
  /** Есть ли ответ на «причина» **/
  dealTypeExExists: boolean;
  /** Состояние кнопки для стейта первого блока заявки **/
  action: EAction;
}

export enum EAction {
  /** Заявка отправлена **/
  'RequestSent' = 'requestSent',
  /** Показать состояние с кнопкой на оставить заявку в листинг **/
  'SendRequest' = 'sendRequest',
  /** Показать состояние с кнопкой-редиректом на новую заявку риелтору  **/
  'RealtorForm' = 'realtorForm',
}
